
<ng-template #plist let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Product Line</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="table w-100">
			<table class="table table-sm w-100">
				<tr>
					<th>ITEM</th>
					<th>DESC</th>
					<th class="text-center w-10">QOH</th>
				</tr>
				<tr *ngFor="let i of vieingpline.details">
					<td>{{i.stockid}}</td>
					<td>{{i.description}}</td>
					<td class="text-center w-10">{{i.qoh}}</td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #lineEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title text-primary" id="modal-title">
			<i class="fa fa-cubes me-2"></i> Edit Product Line
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>

	<div class="modal-body text-dark">
		<form [formGroup]="productLineForm" class="container-fluid">
			<div class="card mb-4 border-start border-3 border-primary">
				<div class="card-body">
					<h6 class="card-title text-primary mb-3 d-flex align-items-center">
						<i class="fa fa-info-circle me-2"></i>&nbsp;&nbsp;Line Details
					</h6>
					<div class="row">
						<div class="col-md-3 mb-3">
							<mat-form-field appearance="outline" class="w-100">
								<mat-label>Line #</mat-label>
								<input
									matInput
									formControlName="line_field"
									maxlength="6"
									required />
								<mat-hint align="end">
									{{ productLineForm.get('line_field')?.value?.length || 0 }}/6 Characters Max
								</mat-hint>
								<mat-error *ngIf="productLineForm.get('line_field')?.hasError('required')">
									This field is required
								</mat-error>
							</mat-form-field>
						</div>

						<div class="col-md-4 mb-3">
							<mat-form-field appearance="outline" class="w-100">
								<mat-label>Description</mat-label>
								<input
									matInput
									formControlName="line_description"
									maxlength="50"
									required />
								<mat-hint align="end">
									{{ productLineForm.get('line_description')?.value?.length || 0 }}/50 Characters Max
								</mat-hint>
								<mat-error *ngIf="productLineForm.get('line_description')?.hasError('required')">
									This field is required
								</mat-error>
							</mat-form-field>
						</div>
						<div class="col-md-3 mb-3">
							<mat-form-field appearance="outline" class="w-100">
								<mat-label>Associated Brand</mat-label>
								<mat-select formControlName="plinebrand" (selectionChange)="onCopySourceSelected($event.value)">
									<mat-option value="">— None —</mat-option>
									<mat-option *ngFor="let pline of manufacturers"
										[value]="pline.manufacturer_id">
										{{ pline.name }} — {{ pline.description }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-2 mb-3 mt-1 d-flex align-items-center" *ngIf="config.env.package == 'beauty'">
							<mat-slide-toggle formControlName="requirescontract" color="accent">
								Requires Contract
							</mat-slide-toggle>
						</div>
					</div>
				</div>
			</div>

			<div class="card mb-3  border-start border-3 border-info">
				<div class="card-body">
					<h6 class="card-title text-info mb-3 d-flex align-items-center">
						<i class="fa fa-copy me-2"></i> &nbsp;&nbsp;Copy Markups From (Optional)
					</h6>
					<div class="row">
						<div class="col-md-8">
							<mat-form-field appearance="outline" class="w-100">
								<mat-label>Select Product Line</mat-label>
								<mat-select formControlName="copyfromline" (selectionChange)="onCopySourceSelected($event.value)">
									<mat-option value="">— None —</mat-option>
									<mat-option *ngFor="let pline of productlines"
										[value]="pline.line_field"
										[disabled]="pline.line_field === productLineForm.get('line_field')?.value">
										{{ pline.line_field }} — {{ pline.line_description }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-3 mb-3 d-flex align-items-center">
							<mat-slide-toggle formControlName="copycustomermatrix" color="primary">
								Copy Customer Matrix
							</mat-slide-toggle>
						</div>
					</div>

				</div>
			</div>

			<div class="card mb-3  border-start border-3 border-info" *ngIf="config.env.package == 'tires'">
				<div class="card-body">
					<h6 class="card-title text-warning d-flex align-items-center mb-3">
						<i class="fa fa-copy me-2"></i> &nbsp;&nbsp;Copy Markups To (Optional)
						<span class="pos-abs-right text-dark">Product Line <mat-slide-toggle [formControl]="copytomfg" ></mat-slide-toggle> MFG</span>
					</h6>
					<div class="row">
						<div class="col-md-8">
							
							<ng-container *ngIf="!copytomfg.value">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Select Product Line</mat-label>
									<mat-select formControlName="copytoline" (selectionChange)="onCopySourceSelected($event.value)" multiple>
										<mat-option value="">— None —</mat-option>
										<mat-option *ngFor="let pline of productlines"
											[value]="pline.line_field"
											[disabled]="pline.line_field === productLineForm.get('line_field')?.value">
											{{ pline.line_field }} — {{ pline.line_description }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</ng-container>

							<ng-container *ngIf="copytomfg.value">
								<div class="row m-0 p-0 w-100">
									<mat-form-field appearance="outline" class="col-6 m-0 p-0">
										<mat-label>Select MFG</mat-label>
										<mat-select [formControl]="mfgfilter">
											<mat-option *ngFor="let pline of brandlines | keyvalue"
												[value]="pline.key">
												{{ pline.key }}
											</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="outline" class="col-6 m-0 p-0">
										<mat-label>Select MFG Product Lines</mat-label>
										<mat-select formControlName="copytoline" (selectionChange)="onCopySourceSelected($event.value)" multiple appSelectAll>
											<mat-option *ngFor="let pline of brandlines[mfgfilter.value]"
												[value]="pline.value"
												[disabled]="pline.line_field === productLineForm.get('line_field')?.value">
												{{ pline.view }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

							</ng-container>
							
						</div>
						<div class="col-md-3 mb-3 d-flex align-items-center">
							<mat-slide-toggle formControlName="copycustomermatrix" color="primary">
								Copy Customer Matrix
							</mat-slide-toggle>
						</div>
					</div>

				</div>
			</div>
		</form>
	</div>


	<!-- 💾 Modal Footer -->
	<div class="modal-footer justify-content-center bg-light py-3">
		<button mat-raised-button color="success" (click)="saveProductLine()" [disabled]="!productLineForm.valid">
			<mat-icon>save</mat-icon> Save
		</button>
		<button mat-stroked-button color="warn" (click)="modal.dismiss('cancel')">
			<mat-icon>close</mat-icon> Cancel
		</button>
	</div>
</ng-template>




<ng-template #plineMerge let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div *ngIf="productLineMergeForm">

			<form [formGroup]="productLineMergeForm">
				<div class="row">
					<div class="col-4 border-1">
						<h4>FROM<br>
							<mat-checkbox formControlName="removeold" [disabled]="partialmerge.value == true">Remove Product Line</mat-checkbox>
						</h4>
						<!--
						<mat-form-field class="full-width" appearance="outline">
							<mat-label>Product Line</mat-label>
							<input type="text" #fromLine matInput formControlName="fromlineid" [matAutocomplete]="fromLines" appSelectOnFocus>
							<mat-autocomplete #fromLines="matAutocomplete" (optionSelected)="selectPline($event)" [displayWith]="displayFn">
								<mat-option *ngFor="let line of filteredproductlines" [value]="line">
									<b>{{line.line_field}}</b> - {{ line.line_description }}
								</mat-option>
							</mat-autocomplete>
						</mat-form-field> -->
						<mat-form-field appearance="outline" class="full-width">
							<mat-label>Product Line</mat-label>
							<mat-select formControlName="fromlineid" (selectionChange)="selectPline($event)">
								<mat-option *ngFor="let line of filteredproductlines" [value]="line">
									<b>{{line.line_field}}</b> - {{ line.line_description }}
								</mat-option>
							</mat-select>
						</mat-form-field>

					</div>

					<div class="col-4 border-1">
						<h4>TO<br>
							<mat-checkbox formControlName="renameitems">Rename Items</mat-checkbox>
						</h4>
						<!-- <mat-form-field class="full-width" appearance="outline">
							<mat-label>Product Line</mat-label>
							<input type="text" #toLine matInput formControlName="tolineid" [matAutocomplete]="toLines" appSelectOnFocus>
							<mat-autocomplete #toLines="matAutocomplete" (optionSelected)="selectPline($event)" [displayWith]="displayFn">
								<mat-option *ngFor="let line of filteredproductlines" [value]="line">
									<b>{{line.line_field}}</b> - {{ line.line_description }}
								</mat-option>
							</mat-autocomplete>
						</mat-form-field> -->
						<mat-form-field appearance="outline" class="full-width">
							<mat-label>Product Line</mat-label>
							<mat-select formControlName="tolineid" (selectionChange)="selectPline($event)">
								<mat-option *ngFor="let line of filteredproductlines" [value]="line">
									<b>{{line.line_field}}</b> - {{ line.line_description }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-4 border-1">
						<h4>PARTIAL<br>
							<mat-checkbox formControlName="partialmerge">Partially Merge Product Line</mat-checkbox>
						</h4>
					</div>
				</div>
				<ng-container *ngIf="allowmmerge">
					<span *ngIf="allowmmerge.length">
						{{ allowmmerge.length }} ITEMS EXIST
					</span>
				</ng-container>

				<button mat-stroked-button color="success" aria-label="" (click)="mergeProductLines()" class="mt-2" *ngIf="!merging">
					<mat-icon>call_merge</mat-icon> merge
				</button>

				<div *ngIf="merging">
					<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
						</circle>
					</svg>
				</div>

			</form>
			<h4>Items</h4>
			<div class="table w-100" *ngIf="controlsReady == true">
				<table class="table table-sm w-100">
					<tr>
						<th *ngIf="partialmerge.value == true">Action</th>
						<th>ITEM</th>
						<th>DESC</th>
						<th>QOH</th>
						<th>NEW ITEM</th>
						<th></th>
					</tr>
					<tr *ngFor="let i of vieingpline.details" [ngClass]="partialMergeItemsControls[i.stockid].value == true ? 'selected_row': ''">
						<td *ngIf="partialmerge.value == true">
							<mat-checkbox [formControl]="this.partialMergeItemsControls[i.stockid]" class="partial-check"></mat-checkbox>
						</td>
						<td>{{i.stockid}}</td>
						<td>{{i.description}}</td>
						<td class="text-center w-10">{{i.qoh}}</td>
						<td class="text-center w-10">
							<span *ngIf="productLineMergeForm.get('renameitems').value">
								{{ previewNewStockid(i.stockid, selectedto )}}
							</span>
							<span *ngIf="!productLineMergeForm.get('renameitems').value">
								n/a
							</span>
						</td>
						<td>
							<span *ngIf="productLineMergeForm.get('renameitems').value">
								{{ itemExist(previewNewStockid(i.stockid, selectedto )) }}
							</span>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #plinebatchdis let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		<h4>Batch {{batchType}}</h4>
	</div>
	<div class="modal-body text-dark">
		<div class="row justify-content-between p-3">
			<div class="d-flex ">
				<button mat-raised-button (click)="allControls('select')">Select All</button>&nbsp;
				<button mat-raised-button (click)="allControls('deselect')">Deselect All</button>
			</div>
			<h4>{{vieingpline.line_description}} ({{vieingpline.line_field}}) Items</h4>
			<button mat-raised-button color="accent" (click)="completeBatch()">{{batchType}}</button>
		</div>
		<div class="table w-100">
			<table class="table table-sm w-100">
				<tr>
					<th>ACTION</th>
					<th>ITEM</th>
					<th>DESC</th>
					<th>QOH</th>
					<th>STATUS</th>
					<th>NEW STATUS</th>
				</tr>
				<tr *ngFor="let i of vieingpline.details" [ngClass]="partialMergeItemsControls[i.stockid].value == true ? 'dis_row' : ''">
					<td>
						<mat-checkbox [formControl]="this.partialMergeItemsControls[i.stockid]" class="partial-check"></mat-checkbox>
					</td>
					<td>{{i.stockid}}</td>
					<td>{{i.description}}</td>
					<td class="text-center w-10">{{i.qoh}}</td>
					<td class="text-center ">
						<ng-container *ngIf="batchType == 'Disable'">
							<ng-container *ngIf="i.enabled == 0">Disabled</ng-container>
							<ng-container *ngIf="i.enabled == 1">Active</ng-container>
						</ng-container>
						<ng-container *ngIf="batchType == 'Discontinue'">
							<ng-container *ngIf="i.discontinued == 0">Active</ng-container>
							<ng-container *ngIf="i.discontinued == 1">Discontinued</ng-container>
						</ng-container>
					</td>
					<td class="text-center ">
						<ng-container *ngIf="batchType == 'Disable'">
							<ng-container *ngIf="partialMergeItemsControls[i.stockid].value == true">Disabled</ng-container>
							<ng-container *ngIf="partialMergeItemsControls[i.stockid].value == false">Active</ng-container>
						</ng-container>
						<ng-container *ngIf="batchType == 'Discontinue'">
							<ng-container *ngIf="partialMergeItemsControls[i.stockid].value == true">Discontinued</ng-container>
							<ng-container *ngIf="partialMergeItemsControls[i.stockid].value == false">Active</ng-container>
						</ng-container>
					</td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<ng-template #categoryEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Edit</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">
						<div class="col-12">
							<form [formGroup]="categoryForm">

								<mat-form-field appearance="outline">
									<mat-label>Category#</mat-label>
									<input type="text" class="text-left " matInput formControlName="categoryid" />
								</mat-form-field>

								<mat-form-field appearance="outline">
									<mat-label>Description</mat-label>
									<input type="text" class="text-left " matInput formControlName="categorydescription" />
								</mat-form-field>
								<br>
								<mat-label>Category Type</mat-label>
								<ng-select [items]="cattypes" bindLabel="catLabel" bindValue="label" formControlName="stocktype">
								</ng-select>
								<br>
								<mat-label>Stock G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="stockact">
								</ng-select>
								<br>
								<mat-label>Adjustment G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="adjglact">
								</ng-select>
								<br>
								<mat-label>Purchase Price Variance G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="purchpricevaract">
								</ng-select>
								<br>
								<mat-label>Purchase Quantity Variance G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="purchqtyvaract">
								</ng-select>
								<br>
								<mat-label>Issue G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="issueglact">
								</ng-select>
								<br>
								<mat-label>Material Usage G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="materialuseagevarac">
								</ng-select>
								<br>
								<mat-label>WIP G/L Account</mat-label>
								<ng-select [items]="glaccounts" bindLabel="acctLabel" bindValue="accountcode" formControlName="wipact">
								</ng-select>
								<br>
								<mat-label>Default Tax Category</mat-label>
								<ng-select [items]="taxcats" bindLabel="taxcatname" bindValue="taxcatid" formControlName="defaulttaxcatid">
								</ng-select>
								<ng-container *ngIf="showProdPostingGroupUi">
									<br>
									<mat-label>Posting group</mat-label>
									<ng-select [items]="prodPostingGroups" bindLabel="name" bindValue="code" formControlName="gen_prod_posting_group" [clearable]="true" placeholder="Category default">
									</ng-select>
								</ng-container>
								<br>

								<button mat-stroked-button color="success" aria-label="" (click)="saveCategory()" class="mt-2">
									<mat-icon>save</mat-icon> Save
								</button>

							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #manuEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title text-primary" id="modal-title">
			<i class="fa fa-industry me-2"></i> Edit Manufacturer
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<form [formGroup]="manufacturerForm" class="container-fluid">
			<div class="row">
				<div class="col-md-6 mb-3">
					<mat-slide-toggle formControlName="isactive" color="primary">Enabled</mat-slide-toggle>
				</div>
				<div class="col-md-6 mb-3">
					<mat-slide-toggle formControlName="special" color="accent">Luxury / Special</mat-slide-toggle>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>MFG Code</mat-label>
						<input matInput formControlName="mfg_code" />
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Name</mat-label>
						<input matInput formControlName="name" />
					</mat-form-field>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Sort Order</mat-label>
						<input matInput type="number" formControlName="sort_order" />
					</mat-form-field>
				</div>
				<div class="col-md-4 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Shorthand ID</mat-label>
						<input matInput formControlName="shorthand_id" />
					</mat-form-field>
				</div>
				<div class="col-md-4 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Discount %</mat-label>
						<input matInput type="number" formControlName="discount_percent" />
					</mat-form-field>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Discount Value</mat-label>
						<input matInput type="number" formControlName="discount_value" />
					</mat-form-field>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Warehouses</mat-label>
						<input matInput formControlName="warehouses" placeholder="e.g. 01, 03" />
					</mat-form-field>
				</div>
				<div class="col-md-6 mb-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Website URL</mat-label>
						<input matInput formControlName="url" />
					</mat-form-field>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer justify-content-center bg-light py-3">
		<button mat-raised-button color="primary" (click)="saveManufacturer()" [disabled]="!manufacturerForm.valid">
			<mat-icon>save</mat-icon> Save
		</button>
		<button mat-stroked-button color="warn" (click)="modal.dismiss('cancel')">
			<mat-icon>close</mat-icon> Cancel
		</button>
	</div>
</ng-template>
<ng-template #plmEdit let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Edit PLM</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<app-prodline-markups [line_field]="selected_linefield" (updateProductLines)="onProductLinesUpdate()"></app-prodline-markups>
	</div>
	<div class="modal-footer">
		<!-- <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancel click')">Cancel</button> -->
	</div>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Inventory
							Settings</h4>
						<p class="card-category"></p>
					</div>
					<div class="card-body">
						<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent" >
							<mat-tab label="Product Lines">

								<ng-template matTabContent>
									<button mat-stroked-button color="success" aria-label="" (click)="addProductLine()" class="mt-2 mb-2">
										<mat-icon>add</mat-icon> Add Product Line
									</button>

									&nbsp;&nbsp;<button class="btn btn-sm btn-danger" (click)="pdfPline()" [disabled]="!searchingproductlines.length"><i class="fa fa-file-pdf-o"></i></button>
									&nbsp;&nbsp;<button class="btn btn-sm btn-success" (click)="excelPline()" [disabled]="!searchingproductlines.length"><i class="fa fa-file-excel-o"></i></button>

									<div class="container-fluid">
										<div class="table ov">
											<div class="text-right"> Results ({{searchingproductlines.length}})</div>
											<div class="row m-0 p-0">
												<div class="col-6">
													<mat-form-field appearance="outline">
														<mat-label>Search</mat-label>
														<input type="text" class="text-left" matInput [formControl]="plinesearch" />
													</mat-form-field>
												</div>
												<div class="col-6">
													<mat-paginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
												</div>
											</div>
												<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" #productLines>
													<thead class="header">
														<tr>
															<th class="header" scope="col">Code#</th>
															<th class="header" scope="col">Description</th>
															<th class="header text-center" scope="col">#Items</th>
															<th class="header text-center">MFG</th>
															<th *ngFor="let t of salestypes" class="header text-center w-10" scope="col">{{t.typeabbrev }} - {{ t.sales_type }}</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let p of dataObs | async; trackBy: trackByLineField" class="prodline-row">
															<td>
																<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More">
																	<mat-icon>more_vert</mat-icon>
																</button>
																<mat-menu #menu="matMenu">
																	<button mat-menu-item color="accent" aria-label="" (click)="editPLM(p)">
																		<mat-icon>cloud</mat-icon> Markups
																	</button>
																	<button mat-menu-item color="accent" aria-label="" (click)="lineMergeForm(p)">
																		<mat-icon>call_merge</mat-icon> Merge
																	</button>

																	<button mat-menu-item (click)="viewProducts(p)">
																		<mat-icon>view_list</mat-icon> View Items
																	</button>
																	<button mat-menu-item color="danger" aria-label="" (click)="removeProductLine(p)">
																		<mat-icon>remove</mat-icon> Remove
																	</button>
																	<button mat-menu-item color="success" aria-label="" (click)="editProductLine(p)">
																		<mat-icon>edit</mat-icon> Edit
																	</button>
																	<button mat-menu-item color="success" aria-label="" *ngIf="canChangeInventoryItemStatus()" (click)="disableProductline(p)">
																		<mat-icon>unpublished</mat-icon> Web Disable
																	</button>
																	<button mat-menu-item color="success" aria-label="" *ngIf="canChangeInventoryItemStatus()" (click)="discontinueProductline(p)">
																		<mat-icon>block</mat-icon> Discontinue
																	</button>

																</mat-menu>
															</td>
															<td>{{ p.line_field }} - {{ p.line_description }}</td>
															<td class="text-center">{{ p.count }}</td>
															<td class="text-center">{{p.mfgbrand}}</td>
															<td *ngFor="let pa of p.plm" class="text-center">
																<ng-container *ngIf="pa.ispricebook">
																	<div class="row w-100 m-0 p-0 mt-1">
																		<div class="lvl-span col-6 w-100 m-0 p-0 mat-elevation-z2" [ngClass]="pa.id == '-1' ? 'lvl-span-nonactive lvl-span-na' : 'lvl-span-active'">
																			{{ pa.pricebasis }}
																		</div>
																		<div class="lvl-span col-6 w-100 m-0 p-0 mat-elevation-z2" [ngClass]="pa.id == '-1' ? 'lvl-span-active' : 'lvl-span-nonactive'">
																			<span class="fs-sm">FB:&nbsp;</span> {{ pa.fallback }}
																		</div>
																	</div>
																	<br>
																	{{ pa.operator_label }}
																	{{ pa.amount }}
																</ng-container>
																<ng-container *ngIf="!pa.ispricebook">
																	<div class="lvl-span lvl-span-active row col-12 w-100 m-0 p-0 mt-1 mat-elevation-z2 justify-content-center" [ngClass]="pa.id == '-1' ? 'lvl-span-na' : ''">{{pa.pricebasis}}</div>
																	<br>
																	{{ pa.operator_label }} {{ pa.amount }}
																</ng-container>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
								</ng-template>
							</mat-tab>

							<mat-tab label="Price Levels">
								<ng-template matTabContent>
									<app-price-level-pricing></app-price-level-pricing>
								</ng-template>
							</mat-tab>


							<mat-tab label="Locations">
								<ng-template matTabContent>
									<app-inventory-locations></app-inventory-locations>
								</ng-template>
							</mat-tab>

							<mat-tab label="Categories">
								<ng-template matTabContent>
									<button mat-stroked-button color="success" aria-label="" (click)="addCategory()" class="mt-2 mb-2">
										<mat-icon>add</mat-icon> Add Category
									</button>

									<table class="table table-sm table-striped table-hover table-bordered table-fixed ov">
										<thead>
											<tr>
												<th>Code#</th>
												<th>Description</th>
												<th>Type</th>
												<th>Stock Acc#</th>
												<th>Adj Acc#</th>
												<th>Issue Acc#</th>
												<th>Purchase Price Var Acc#</th>
												<th>Purchase Qty Var Acc#</th>
												<th>Useage Acc#</th>
												<th>WIP Acc#</th>
												<th>Default Tax Cat#</th>
												<th *ngIf="showProdPostingGroupUi">Posting grp.</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let p of categories; trackBy: trackByCategoryId">

												<td>{{ p.categoryid }}</td>
												<td>{{ p.categorydescription }}</td>
												<td>{{ p.stocktype }}</td>
												<td>{{ p.stockact }}</td>
												<td>{{ p.adjglact }}</td>
												<td>{{ p.issueglact }}</td>
												<td>{{ p.purchpricevaract }}</td>
												<td>{{ p.purchqtyvaract }}</td>
												<td>{{ p.materialuseagevarac }}</td>
												<td>{{ p.wipact }}</td>
												<td>{{ p.defaulttaxcatid }}</td>
												<td *ngIf="showProdPostingGroupUi">{{ p.gen_prod_posting_group }}</td>
												<td>
													<button mat-stroked-button color="danger" aria-label="" (click)="removeCategory(p)" class="mt-2">
														<mat-icon>remove</mat-icon> Remove
													</button>
													<button mat-stroked-button color="success" aria-label="" (click)="editCategory(p)" class="mt-2">
														<mat-icon>edit</mat-icon> Edit
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</ng-template>
							</mat-tab>
							<mat-tab label="Units of Measure">
								<ng-template matTabContent>
									<div class="d-flex align-items-center gap-2 mt-3 mb-2">
										<mat-form-field appearance="outline" style="max-width: 220px;">
											<mat-label>New unit name</mat-label>
											<input matInput [(ngModel)]="newunitname" maxlength="15" placeholder="e.g. case" (keyup.enter)="addUnitOfMeasure()">
										</mat-form-field>
										<button mat-stroked-button color="success" aria-label="" (click)="addUnitOfMeasure()">
											<mat-icon>add</mat-icon> Add Unit
										</button>
									</div>

									<table class="table table-sm table-striped table-hover table-bordered table-fixed ov">
										<thead>
											<tr>
												<th>Unit Name</th>
												<th>Items Using</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let u of unitsofmeasure; trackBy: trackByUnitId">
												<td>
													<input matInput [(ngModel)]="u.unitname" maxlength="15" (blur)="saveUnitOfMeasure(u)" (keyup.enter)="saveUnitOfMeasure(u)">
												</td>
												<td>{{ u.item_count }}</td>
												<td>
													<button mat-stroked-button color="danger" aria-label="" (click)="removeUnitOfMeasure(u)"
														[disabled]="u.item_count > 0 || u.unitname?.toLowerCase() === 'each'">
														<mat-icon>remove</mat-icon> Remove
													</button>
												</td>
											</tr>
											<tr *ngIf="unitsofmeasure.length === 0">
												<td colspan="3" class="text-center text-muted">No units of measure defined.</td>
											</tr>
										</tbody>
									</table>
								</ng-template>
							</mat-tab>
							<mat-tab label="GL Classes">
								<ng-template matTabContent>
									<app-gl-classes></app-gl-classes>
								</ng-template>
							</mat-tab>
							<!-- <mat-tab label="Hazards">
							</mat-tab>
							<mat-tab label="Rebates">
							</mat-tab> -->
							<mat-tab label="Manufacturer">
								<ng-template matTabContent>
									<div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2 mb-2">
										<div class="d-flex align-items-center gap-2">
											<button mat-stroked-button color="primary" (click)="addManufacturer()">
												<mat-icon>add</mat-icon> Add Manufacturer
											</button>
											<button class="btn btn-sm btn-danger" (click)="exportMfgPdf()" [disabled]="exportingMfg || !mfgDataSource.data?.length">
												<i class="fa fa-file-pdf-o"></i> PDF
											</button>
											<button class="btn btn-sm btn-success" (click)="exportMfgXlsx()" [disabled]="exportingMfg || !mfgDataSource.data?.length">
												<i class="fa fa-file-excel-o"></i> XLSX
											</button>
										</div>
										<mat-form-field appearance="outline" class="mfg-search-field">
											<mat-label>Search</mat-label>
											<input matInput type="text" [formControl]="mfgSearch" placeholder="Code, name, shorthand, warehouses..." />
											<mat-icon matSuffix>search</mat-icon>
										</mat-form-field>
									</div>
									<div class="container-fluid">
										<div class="mb-1">Results ({{ (mfgDataSource.filteredData || mfgDataSource.data || []).length }})</div>
										<div class="table-responsive">
											<table mat-table [dataSource]="mfgDataSource" [trackBy]="trackByMfgId" matSort #mfgSort="matSort" class="table table-sm table-striped table-hover table-bordered table-fixed ov mat-table-flat mfg-table">
												<ng-container matColumnDef="enabled">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" (click)="quickToggle(p, 'isactive')">
														<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
															<span class="mfg-code-view">{{ p.isactive ? 'Yes' : 'No' }}</span>
															<mat-icon class="hover-icon">swap_horiz</mat-icon>
														</div>
													</td>
												</ng-container>
												<ng-container matColumnDef="luxury" *ngIf="config.env.package == 'beauty'">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Luxury</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" (click)="quickToggle(p, 'special')">
														<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
															<span class="mfg-code-view">{{ p.special == 1 ? 'Yes' : 'No' }}</span>
															<mat-icon class="hover-icon">swap_horiz</mat-icon>
														</div>
													</td>
												</ng-container>
												<ng-container matColumnDef="mfg_code">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>MFG Code</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'mfg_code'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'mfg_code'" (click)="quickInput(p, 'mfg_code')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.mfg_code }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'mfg_code'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.mfg_code" autocomplete="off" (input)="validateManufacturerEdit(p, 'mfg_code', $event.target)" [class.mfg_field_used]="!mfg_edit_valid" id="{{p.manufacturer_id}}mfg_code">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="!mfg_edit_valid" (click)="saveQuickInput(p, 'mfg_code', mfg_edit_valid)">
																		<mat-icon *ngIf="!mfg_edit_valid" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="!mfg_edit_valid" class="mfg-code-error">
																	<ng-container *ngIf="mfg_edit_valid === ''">can't be empty</ng-container>
																	<ng-container *ngIf="mfg_edit_valid !== ''">value in use</ng-container>
																</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="name">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'name'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'name'" (click)="quickInput(p, 'name')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.name }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'name'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.name" autocomplete="off" (input)="validateManufacturerEdit(p, 'name', $event.target)" [class.mfg_field_used]="!mfg_edit_valid" id="{{p.manufacturer_id}}name">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="!mfg_edit_valid" (click)="saveQuickInput(p, 'name', mfg_edit_valid)">
																		<mat-icon *ngIf="!mfg_edit_valid" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="!mfg_edit_valid" class="mfg-code-error">
																	<ng-container *ngIf="mfg_edit_valid === ''">can't be empty</ng-container>
																	<ng-container *ngIf="mfg_edit_valid !== ''">value in use</ng-container>
																</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="sort_order">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Sort Order</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'sort_order'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'sort_order'" (click)="quickInput(p, 'sort_order')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.sort_order }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'sort_order'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.sort_order" autocomplete="off" type="number" (input)="validateManufacturerEdit(p, 'sort_order', $event.target, 'number')" [class.mfg_field_used]="!mfg_edit_valid" id="{{p.manufacturer_id}}sort_order">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="!mfg_edit_valid" (click)="saveQuickInput(p, 'sort_order', mfg_edit_valid)">
																		<mat-icon *ngIf="!mfg_edit_valid" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="!mfg_edit_valid" class="mfg-code-error">
																	<ng-container *ngIf="mfg_edit_valid === ''">can't be empty</ng-container>
																	<ng-container *ngIf="mfg_edit_valid !== ''">value not valid</ng-container>
																</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="shorthand_id">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Shorthand ID</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'shorthand_id'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'shorthand_id'" (click)="quickInput(p, 'shorthand_id')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.shorthand_id }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'shorthand_id'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.shorthand_id" autocomplete="off" (input)="validateManufacturerEdit(p, 'shorthand_id', $event.target)" [class.mfg_field_used]="mfg_edit_valid === false" id="{{p.manufacturer_id}}shorthand_id">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="mfg_edit_valid === false" (click)="saveQuickInput(p, 'shorthand_id', mfg_edit_valid)">
																		<mat-icon *ngIf="mfg_edit_valid === false" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid || mfg_edit_valid === ''">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="!mfg_edit_valid" class="mfg-code-error">
																	<ng-container *ngIf="mfg_edit_valid !== ''">value in use</ng-container>
																</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="discount_percent">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Discount %</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'discount_percent'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'discount_percent'" (click)="quickInput(p, 'discount_percent')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.discount_percent }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'discount_percent'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.discount_percent" autocomplete="off" type="float" (input)="validateManufacturerEdit(p, 'discount_percent', $event.target, 'float')" [class.mfg_field_used]="!mfg_edit_valid" id="{{p.manufacturer_id}}discount_percent">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="!mfg_edit_valid" (click)="saveQuickInput(p, 'discount_percent', mfg_edit_valid)">
																		<mat-icon *ngIf="!mfg_edit_valid" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="!mfg_edit_valid" class="mfg-code-error">
																	<ng-container *ngIf="mfg_edit_valid === ''">can't be empty</ng-container>
																	<ng-container *ngIf="mfg_edit_valid !== ''">value not valid</ng-container>
																</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="discount_value">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Discount Value</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'discount_value'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'discount_value'" (click)="quickInput(p, 'discount_value')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.discount_value }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'discount_value'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.discount_value" autocomplete="off" type="float" (input)="validateManufacturerEdit(p, 'discount_value', $event.target, 'float')" [class.mfg_field_used]="!mfg_edit_valid" id="{{p.manufacturer_id}}discount_value">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="!mfg_edit_valid" (click)="saveQuickInput(p, 'discount_value', mfg_edit_valid)">
																		<mat-icon *ngIf="!mfg_edit_valid" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="!mfg_edit_valid" class="mfg-code-error">
																	<ng-container *ngIf="mfg_edit_valid === ''">can't be empty</ng-container>
																	<ng-container *ngIf="mfg_edit_valid !== ''">value not valid</ng-container>
																</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="warehouses">
													<th mat-header-cell *matHeaderCellDef mat-sort-header>Warehouses</th>
													<td mat-cell *matCellDef="let p" class="quick-toggle mfg-code-cell" [class.mfg-code-editing]="openQuickInput == p.manufacturer_id + 'warehouses'" >
														<div *ngIf="!openQuickInput || openQuickInput != p.manufacturer_id+'warehouses'" (click)="quickInput(p, 'warehouses')">
															<div class="row justify-content-between m-0 pl-1 pr-1 pt-0 pb-0">
																<span class="mfg-code-view">{{ p.warehouses }}</span>
																<mat-icon class="hover-icon">edit</mat-icon>
															</div>
														</div>
														<ng-container *ngIf="openQuickInput == p.manufacturer_id + 'warehouses'">
															<div class="mfg-code-edit-wrapper">
																<mat-form-field appearance="fill" class="mfg-code-field">
																	<button mat-icon-button matPrefix class="mfg-code-cancel" aria-label="Cancel" (click)="cancelQuickInput()">
																		<mat-icon>cancel</mat-icon>
																	</button>
																	<input matInput [value]="p.warehouses" autocomplete="off" type="float" (input)="validateManufacturerEdit(p, 'warehouses', $event.target, 'numberCommaNumber')" [class.mfg_field_used]="mfg_edit_valid === false" id="{{p.manufacturer_id}}warehouses">
																	<button mat-icon-button matSuffix class="mfg-code-save" aria-label="Save" [disabled]="mfg_edit_valid === false" (click)="saveQuickInput(p, 'warehouses', mfg_edit_valid)">
																		<mat-icon *ngIf="mfg_edit_valid === false" class="not-valid">save</mat-icon>
																		<mat-icon *ngIf="mfg_edit_valid || mfg_edit_valid === ''">save</mat-icon>
																	</button>
																</mat-form-field>
																<mat-error *ngIf="mfg_edit_valid === false" class="mfg-code-error">value not valid</mat-error>
															</div>
														</ng-container>
													</td>
												</ng-container>
												<ng-container matColumnDef="actions">
													<th mat-header-cell *matHeaderCellDef class="text-center" style="width: 80px;">Actions</th>
													<td mat-cell *matCellDef="let p" class="text-center">
														<button mat-icon-button [matMenuTriggerFor]="mfgRowMenu" aria-label="Actions">
															<mat-icon>more_vert</mat-icon>
														</button>
														<mat-menu #mfgRowMenu="matMenu">
															<button mat-menu-item (click)="editManufacturer(p)">
																<mat-icon>edit</mat-icon> Edit
															</button>
															<button mat-menu-item *ngIf="canChangeInventoryItemStatus()" (click)="disableManufacturer(p)">
																<mat-icon>unpublished</mat-icon> Web Disable
															</button>
															<button mat-menu-item *ngIf="canChangeInventoryItemStatus()" (click)="discontinueManufacturer(p)">
																<mat-icon>block</mat-icon> Discontinue
															</button>
															<button mat-menu-item (click)="removeManufacturer(p)">
																<mat-icon>remove</mat-icon> Remove
															</button>
														</mat-menu>
													</td>
												</ng-container>
												<tr mat-header-row *matHeaderRowDef="displayedMfgColumns"></tr>
												<tr mat-row *matRowDef="let row; columns: displayedMfgColumns;"></tr>
												<tr class="mat-row" *matNoDataRow>
													<td class="mat-cell" [attr.colspan]="displayedMfgColumns.length">No manufacturers match your search.</td>
												</tr>
											</table>
										</div>
										<mat-paginator #mfgPaginator [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault" showFirstLastButtons></mat-paginator>
									</div>
								</ng-template>
							</mat-tab>

							<mat-tab label="Forced Cost Override" *ngIf="config.env.package === 'tires'">
							  <ng-template matTabContent>
							  	<app-forced-cost-override></app-forced-cost-override>
							  </ng-template>
							</mat-tab>


							<mat-tab label="Change Stock ID">
								<ng-template matTabContent>
								<ng-container *ngIf="stockidChanged.status == false">
									<div style="display: flex;" @slide>
										<div style="display: flex; justify-content: space-evenly; margin-top: 20px; width: 85%;">
											<mat-form-field style="width: 50%;" appearance="outline">
												<input matInput type="text" placeholder="Search/Scan item" [formControl]="searchbar" (keyup)="$event.stopPropagation();$event.preventDefault();v8search($event.target, false)" (click)="showSearchResults()">
											</mat-form-field>

											<mat-form-field appearance="outline">
												<input matInput type="text" [formControl]="from" placeholder="From">
											</mat-form-field>

											<mat-form-field appearance="outline">
												<input matInput type="text" [formControl]="to" placeholder="To" (keyup)="v8search($event.target, true)">
											</mat-form-field>

										</div>
										<div style="display:flex; width: 15%;">
											<a mat-raised-button style="margin-left: 50px; height: 35px; margin-top: 30px;" (click)="changeStockID()" [disabled]="this.to.valid == false || this.from.valid == false ">Change</a>
										</div>
									</div>
									<div class="table table-responsive text-center searchlist" *ngIf="searchsub">
										<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</div>
									<div class="table table-responsive searchlist" #searhlist *ngIf="searchResults && searchResults.length && viewSearch">
										<table class="tableitem table-sm border-0">
											<thead class="sticky-thead">
												<tr>
													<th></th>
													<th class="text-left">ITEM</th>
													<th class="text-left">DESC
														<mat-icon style="float: right; color: #e26d6d;" (click)="closeSearch()">cancel</mat-icon>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let item of searchResults ">
													<td>
														<a mat-raised-button (click)="loadFrom(item)">From</a>
													</td>
													<td class="text-left">{{ item.stockid }}</td>
													<td class="text-left f12">{{ item.description }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</ng-container>
								<ng-container *ngIf="stockidChanged.status">
									<div style="text-align: center; margin-top: 10px; width: 50%; margin-left: auto; margin-right: auto;" @slide>
										<h3>Stock ID changed from
											<span style="font-weight: bolder; font-style:
												italic;">{{stockidChanged.data.from}}</span>
											<span style="font-weight: lighter"> to </span>
											<span style="font-weight: bolder; font-style: italic;">{{stockidChanged.data.to}}</span>
										</h3>
										<button mat-raised-button color="primary" style="margin-bottom: 10px;" (click)="reset()">Okay</button>
									</div>
								</ng-container>
								</ng-template>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
